import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configurations-index',
  templateUrl: './configurations-index.component.html',
  styleUrls: ['./configurations-index.component.scss']
})
export class ConfigurationsIndexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
